export default "__VITE_ASSET__C$tqyuq4__"